// src/config.js
export const BASE_URL = 'https://chat.onexgames.in';  // or use process.env for flexibility
